export class Address {
    postalCode: string;
    street: string;
    number: string;
    adjunct: string;
    district: string;
    city: string;
    cityName: string;
    state: string;
    stateName: string;
    isCompleted?: boolean;
    editData?: [];
    firstEdit?: [];
}
